import _actions_get from './_actions/get.js'
import _getters_wiki from './_getters/wiki.js'
import _getters_video from './_getters/video.js'
import _mutations_set from './_mutations/set.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        loading: _mutations_loading,
        set: _mutations_set,
    },
    getters:{
        video: _getters_video,
        wiki: _getters_wiki,
    },
    actions:{
        get: _actions_get,
    },
}